
import { Card, makeStyles } from "@material-ui/core";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import Loading from "../../load/loading";
import Date from "../../utils/date";
import { useNavigate } from "react-router-dom";
import ListaVazia from "../../utils/listaVazia";


const useStyles = makeStyles((theme) => ({
    hover: { '&:hover': { backgroundColor: '#85287d8a' }, cursor: 'pointer' },
    container: {
        display: 'flex',
        justifyContent: 'center',
        boxShadow: 'none',
        margin: 10
    },
}))

export default function ListaExpediente({ expedientes }) {
    const classes = useStyles()
    const navigate = useNavigate()

    return (
        expedientes
            ?
            expedientes.length > 0 ?

                <Card variant="outlined" sx={{ width: '100%', overflow: 'hidden' }} >
                    <TableContainer id={'listaParticipacoes'}>
                        <Table size="small" stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center" ><Typography noWrap> <strong>Requerente / Nome </strong></Typography></TableCell>
                                    <TableCell align="center" ><Typography noWrap> <strong>Portador / Remetente </strong></Typography></TableCell>
                                    <TableCell align="center" ><Typography noWrap> <strong> Instituição / B.I ou NIF Empresa / NIF </strong></Typography></TableCell>
                                    <TableCell align="center" ><Typography noWrap> <strong> Nº Entrada </strong></Typography></TableCell>
                                    <TableCell align="center" ><Typography noWrap> <strong> Tipo de Documento </strong></Typography></TableCell>
                                    <TableCell align="center" ><Typography noWrap> <strong> Assunto </strong></Typography></TableCell>
                                    <TableCell align="center" ><Typography noWrap> <strong> Data do Documento </strong></Typography></TableCell>
                                    <TableCell align="center" ><Typography noWrap> <strong> email </strong></Typography></TableCell>
                                    <TableCell align="center" ><Typography noWrap> <strong> contacto </strong></Typography></TableCell>
                                    {/* <TableCell align="center" ><Typography noWrap> <strong> Anexo </strong></Typography></TableCell> */}
                                    <TableCell align="center" ><Typography noWrap> <strong> Data Entrada </strong></Typography></TableCell>
                                    {/* <TableCell align="center" ><Typography noWrap> <strong> Destinatário </strong></Typography></TableCell> */}
                                    <TableCell align="center" ><Typography noWrap> <strong> Visualizar Anexo </strong></Typography></TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {expedientes.map((expediente) => (
                                    <TableRow key={expediente._id} className={classes.hover} onClick={() => navigate(`/admin/expediente/view/${expediente._id}`)}>

                                        <TableCell ><Typography noWrap> {expediente?.remetidoPor?.nome}</Typography></TableCell>
                                        <TableCell ><Typography noWrap> {expediente?.nome}</Typography></TableCell>
                                        <TableCell  ><Typography > {expediente?.nifBi}</Typography></TableCell>
                                        <TableCell align="center"   ><Typography noWrap> {expediente?.numero} </Typography></TableCell>

                                        <TableCell  ><Typography noWrap> {expediente?.tipoDocumento?.designacao}</Typography></TableCell>
                                        <TableCell  ><Typography noWrap> {expediente?.assunto}</Typography></TableCell>
                                        <TableCell align="center" ><Typography noWrap> <Date date={expediente?.createdAt} /> </Typography></TableCell>
                                        <TableCell align="center"   ><Typography noWrap> {expediente?.email} </Typography></TableCell>
                                        <TableCell align="center"   ><Typography noWrap> {expediente?.tel} </Typography></TableCell>
                                        <TableCell align="center" ><Typography noWrap> <Date date={expediente?.createdAt} /> </Typography></TableCell>
                                        {/* <TableCell align="center" > </TableCell> */}
                                        <TableCell align="center" >
                                            <a target="_blank" href={expediente?.anexo} >{expediente?.anexo ? 'Anexo' : ''} </a>
                                            <br />
                                            <a target="_blank" href={expediente?.anexo} >{expediente?.remetidoPor?.anexoBi ? 'B.I do Remetente' : ''} </a>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {/* <FerramentaNavegacaoExportacao
                                FerramentaNavegacaoExportacao={true}
                                // exportToPDF={exportToPDF}
                                // activeImpressao={activeImpressao}
                                configLista={configLista}
                                lista={entradas}
                                page={page}
                                setPage={setPage}
                            /> */}
                </Card >
                :
                <ListaVazia />
            :
            <Loading text={'A carregar expedientes'} />
    )
}
